import React from 'react'
import { Button } from "@mui/material"

export const sxBtnSelect = {
    sx: {
        color:"c_button.contrastText", bgcolor:"c_button.bg",
        "&:hover": { color:"c_button.contrastText", bgcolor:"c_button.bg", },
    }
};

export const sxBtnSelectA = {
    sx: {
        color:"c_button.bg", bgcolor:"c_buttonA.contrastText",
        "&:hover": { color:"c_button.bg", bgcolor:"c_buttonA.contrastText" },
    },
};
/*
export const sxBtnSelectB = {
    sx: {
        color:"c_buttonA.contrastText", bgcolor:"c_buttonA.bg",
        "&:hover": { color:"c_buttonA.contrastText", bgcolor:"c_buttonA.bg", },
    }
};*/

export const sxBtnSelectB = sxBtnSelect;
/*
export const sxBtnSelectB = {
    sx: {
        color:"c_buttonB.contrastText", bgcolor:"c_buttonB.bg",
        "&:hover": { color:"c_buttonB.contrastText", bgcolor:"c_buttonB.bg", },
    }
};*/

export default function ButtonCustomize({
    btn_name,
    onClick,
    btn_height
}) {
    return (
        <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 3, height: btn_height }}
            onClick={() => {
                onClick()
            }}
        >
            {btn_name}
        </Button>
    )
}